import { LODChecklistService, EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
export async function getLODChecklistTasksListener () {
    console.log('ATBase: Received request for LODChecklist.')
    await LODChecklistService.initialize(EnvironmentDetail.getStoreId())
    const lodChecklistTasks = LODChecklistService.getStatusPageTasks()
    const response = {
        lodChecklistServiceTasks: lodChecklistTasks,
    }
    console.log('ATBase: LODChecklist received count: ' + lodChecklistTasks.tasks.length)
    return Promise.resolve(response)
}
